var map = {
	"./ahamove.png": 21751,
	"./ghn.png": 67063,
	"./ghtk.png": 58755,
	"./jntp.png": 98406,
	"./lwe.png": 79750,
	"./shippo.png": 74131,
	"./snappy.png": 37136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25808;